import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=021266d9&scoped=true"
import script from "./cancel.vue?vue&type=script&lang=ts"
export * from "./cancel.vue?vue&type=script&lang=ts"
import style0 from "./cancel.vue?vue&type=style&index=0&id=021266d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021266d9",
  null
  
)

export default component.exports